/* eslint-disable @typescript-eslint/no-empty-function */

import { createContext } from 'react';
import type { ChoosableSubscriptionFrequency } from 'autogen/swagger/all';

export const SubscriptionContext = createContext({
    subscriptionActive: false,
    setSubscriptionActive: (bool: boolean) => {}
});

export const SelectedFrequencyContext = createContext({
    selectedFrequency: {} as ChoosableSubscriptionFrequency | undefined,
    setSelectedFrequency: (obj: ChoosableSubscriptionFrequency) => {}
});
